import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=52fe32a2&scoped=true&"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&id=52fe32a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe32a2",
  null
  
)

export default component.exports